export const CONFIRMATION_TITLE_OUTSIDE_WORKING_HOURS =
  "This is outside the provider's working hours. Are you sure you want to proceed?";

export const CONFIRMATION_TITLE_APPOINTMENT_OVERLAPS =
  "Are you sure you want to overlap existing appointments?";
